var _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBajoImpacto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 81,
    viewBox: "0 0 41 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.9464,
    cy: 17.7224,
    rx: 6.04207,
    ry: 6.79733,
    fill: "#9B5AE6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.9883,
    y: 23.1711,
    width: 14.7329,
    height: 30.8124,
    rx: 7.36644,
    transform: "rotate(19.7637 19.9883 23.1711)",
    fill: "#9B5AE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.623,
    y: 39.8303,
    width: 8.00575,
    height: 40.2185,
    rx: 4.00287,
    transform: "rotate(19.7637 13.623 39.8303)",
    fill: "#9B5AE6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.8413,
    y: 49.4611,
    width: 7.96167,
    height: 32.108,
    rx: 3.98083,
    transform: "rotate(-21.1405 13.8413 49.4611)",
    fill: "#9B5AE6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.71582,
    y: 11.4982,
    width: 6.33132,
    height: 23.6289,
    rx: 3.16566,
    transform: "rotate(-21.1405 9.71582 11.4982)",
    fill: "#9B5AE6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4829,
    width: 5.35954,
    height: 23.5236,
    rx: 2.67977,
    transform: "rotate(58.1456 29.4829 0)",
    fill: "#9B5AE6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.3711,
    y: 43.748,
    width: 6.33132,
    height: 19.4031,
    rx: 3.16566,
    transform: "rotate(146.647 40.3711 43.748)",
    fill: "#9B5AE6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8701,
    y: 54.7445,
    width: 6.33132,
    height: 20.2125,
    rx: 3.16566,
    transform: "rotate(-118.155 22.8701 54.7445)",
    fill: "#9B5AE6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBajoImpacto);
export default __webpack_public_path__ + "static/media/bajo_impacto.9b6faa42fd3c8a3a948ae26bf912fdfc.svg";
export { ForwardRef as ReactComponent };